import React, { useContext, useEffect, useRef, useState } from "react";
import "./GlobalPartStock.css";
import { Sorting } from "../../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { Tooltip } from "@mui/material";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { TransferRequest } from "./TransferRequest";
import { companyStockByPart } from "../../../Services/PartRequestManagementService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";

const SearchBarContainer = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

export const GlobalPartStock = ({ part, onClose }) => {
  //Tooltips
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const [loadingAvailableParts, setLoadingAvailableParts] = useState(false);
  const getSortingOrder = (order) => {};
  const { openDialog, closeDialog } = useContext(DialogContext);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      //if (!setLoadingPartsReq) requestNextPage();
    }
  };
  const [sortingOrder, setSortingOrder] = useState("quantity");
  //service
  const pageSize = 10;
  const [page, setPage] = useState(0);
  const [maxPages, setMaxPages] = useState(null);
  const [search, setSearch] = useState("");
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    setLoadingAvailableParts(true);
    companyStockByPart(
      page,
      pageSize,
      search,
      sortingOrder,
      part.pr_location_id,
      part.part_id
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
          }));

          setDataList(inventoryArray);
          setLoadingAvailableParts(false);
        }
      })
      .catch((error) => setLoadingAvailableParts(false));
  }, [page, search, sortingOrder]);
  const openTransferRequest = (item) => {
    openDialog({
      component: TransferRequest,
      props: {
        part: part,
        location: item,
        close: closeDialog,
        okAction: () => saveSuccess(),
      },
    });
  };
  const saveSuccess = () => {
    console.warn("saveSuccess");
  };
  return (
    <div className="company-stock-full-container">
      <div className="company-stock-header">
        <div className="company-stock-header-info">
          <h3>View Company Stock</h3>
          <div className="company-stock-part-info">
            <div className="company-stock-part-info-item">
              <p>PN</p>
              <b>{part.part_number}</b>
            </div>
            <div className="company-stock-part-info-item">
              <p>PRN</p>
              <b>{part.id}</b>
            </div>
            <div className="company-stock-part-info-item">
              <p>WP</p>
              <b>{part.work_package_id}</b>
            </div>
            <div className="company-stock-part-info-item">
              <p>QTY Requested</p>
              <b>5 EA</b>
            </div>
          </div>
        </div>
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <hr />
      <div className="search-bar-input">
        <SearchBarContainer onSearch={setSearch} />
        <i className="icon-search"></i>
      </div>
      <div className="company-stock-list" ref={listRef} onScroll={handleScroll}>
        <div className="sorting-header">
          <div className="sorting-free-slot"> </div>
          <Sorting
            onOrderChange={getSortingOrder}
        showHeaderOrder={true}
            ignoreProperties={true}
            properties={{
              location_name: "Location",
              site_name: "Site",
              site_type: "Type",
              quantity: "QTY Available",
            }}
          ></Sorting>
        </div>
        {loadingAvailableParts ? (
          // Mostrar esqueletos mientras carga
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          dataList.map((item, idx) => (
            <React.Fragment key={`${item.id}-${idx}`}>
              <div className="item-global-location-container">
                {["location_name", "site_name", "site_type", "quantity"].map(
                  (label) => (
                    <div className="property" key={label}>
                      <Tooltip
                        title={
                          tooltips[`${item.id}-${label}`] ? item[label] : ""
                        }
                        arrow
                      >
                        <p
                          className="light-font"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${item.id}-${label}`] = el;
                            }
                          }}
                        >
                          {label == "quantity"
                            ? item[label] + " " + item["uom_abrevation"]
                            : item[label]}
                        </p>
                      </Tooltip>
                    </div>
                  )
                )}
                <button
                  className="transfer-button-color"
                  onClick={() => openTransferRequest(item)}
                >
                  Transfer Request
                </button>
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </div>
  );
};
